import { SocialProfilesService } from './SocialProfilesService';

export default new SocialProfilesService('facebook/profiles');
